import { defineStore } from "pinia";

import modelClass from "@models/event";
import * as getters from "@modelStores/helpers/getters-helper";

export const useEventStore = defineStore("event-store", {
  state: () => {
    return {
      resources: [] as Record<string, unknown>[],
    };
  },
  getters: {
    ...getters,
    modelClass: () => modelClass,
  },
});
